/** @jsx jsx */
import { jsx } from "theme-ui";
import Menu from "./menu";

const Header = () => {
  return (
    <header
      sx={{
        backgroundColor: "primary",
        padding: ["0px 5%", "0px 2.5rem"],
        position: "fixed",
        boxSizing: "border-box",
        width: "100%",
        zIndex: "99",
        top: "0",
      }}
    >
      <Menu></Menu>
    </header>
  );
};

export default Header;
